import { Box, Grid, TextField, Typography, MenuItem } from "@mui/material";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { IProdutoFormData } from ".";
import SelectAgrotoxico from "../../../../../components/SelectsSimpleApiQuery/SelectAgrotoxico";
import SelectAnpGrupo from "../../../../../components/SelectsSimpleApiQuery/SelectAnpGrupo";

export default function Step03() {
    const { control, formState: { errors } } = useFormContext<IProdutoFormData>();
    const geraLMC = useWatch({ control, name: "precosCustos.geraLMC" });

    return (
        <Box sx={{ py: 2 }}>
            <Typography variant="h6" gutterBottom>
                Preços e Custos
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Configure os dados financeiros e fiscais do produto.
            </Typography>

            <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.financiamento"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Financiamento (Código)"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { step: "1", min: "0" } }}
                                error={!!errors.precosCustos?.financiamento}
                                helperText={errors.precosCustos?.financiamento?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.atualizaPrecoAutomatico"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Atualiza Preço Automático"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.atualizaPrecoAutomatico}
                                helperText={errors.precosCustos?.atualizaPrecoAutomatico?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.precoVenda4Decimais"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Permite 4 decimais preço"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.precoVenda4Decimais}
                                helperText={errors.precosCustos?.precoVenda4Decimais?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.percentualVariacaoCompra"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="% Variação Compra"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { step: "0.1", min: "0", max: "999" } }}
                                error={!!errors.precosCustos?.percentualVariacaoCompra}
                                helperText={errors.precosCustos?.percentualVariacaoCompra?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        control={control}
                        name="precosCustos.pedeValorTotalNF"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Pede Valor Total NF"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.pedeValorTotalNF}
                                helperText={errors.precosCustos?.pedeValorTotalNF?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        control={control}
                        name="precosCustos.estornoCreditoICMS"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Estorno Crédito ICMS"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.estornoCreditoICMS}
                                helperText={errors.precosCustos?.estornoCreditoICMS?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        control={control}
                        name="precosCustos.emiteReceitaAgropecuaria"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Emite Receita Agp"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.emiteReceitaAgropecuaria}
                                helperText={errors.precosCustos?.emiteReceitaAgropecuaria?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.geraLMC"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Gera LMC"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.geraLMC}
                                helperText={errors.precosCustos?.geraLMC?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        name="precosCustos.grupoANP"
                        control={control}
                        rules={{
                            validate: (value) => {
                                if (geraLMC === "S") {
                                    if (!value || typeof value !== "object" || !value.id) {
                                        return "Grupo ANP é obrigatório";
                                    }
                                }
                                return true;
                            }
                        }}
                        render={({ field }) => (
                            <SelectAnpGrupo
                                value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : null}
                                onChange={field.onChange}
                                required={geraLMC === "S"}
                                error={!!errors.precosCustos?.grupoANP}
                                multiple={false}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.registroMinisterioAgricultura"
                        render={({ field }) => (
                            <SelectAgrotoxico
                                value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : null}
                                onChange={field.onChange}
                                label="Registro no Ministério da Agricultura"
                                unique_select
                                error={!!errors.informacoesBasicas?.departamento}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        control={control}
                        name="precosCustos.classificacaoOrigem"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Classificação de Origem"
                                fullWidth
                                required
                                error={!!errors.precosCustos?.classificacaoOrigem}
                                helperText={errors.precosCustos?.classificacaoOrigem?.message}
                            >
                                <MenuItem value="G">Genuíno</MenuItem>
                                <MenuItem value="O">Original</MenuItem>
                                <MenuItem value="P">Paralelo</MenuItem>
                                <MenuItem value="U">Outros</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}